import { configureAuth } from 'react-query-auth';
import { Navigate, useLocation } from 'react-router-dom';
import { z } from 'zod';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import LoadingScreen from '../components/LoadingScreen';

// Define paths for auth routes
export const paths = {
  auth: {
    login: {
      path: '/admin/login',
      getHref: (redirectPath = '') => `/admin/login?redirect=${redirectPath}`,
    },
  },
};

// Cookie helper functions
const getCookie = (name) => {
  // Note: document.cookie may be empty if the cookie has HttpOnly flag
  // In that case, the cookie is still sent in requests but not accessible via JS
  const value = `; ${document.cookie || ''}`; 
  const parts = value.split(`; ${name}=`);
  console.log('Cookie parts:', value, parts);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Auth API functions
const getUser = async () => {
  console.log('Checking user authentication...');

  // Check if we have a session cookie
  const sessionCookie = getCookie('tiga_auth');
  if (!sessionCookie) {
    console.log('No session cookie found');
    return null;
  }
  return sessionCookie;
  // // If we have a session cookie, try to fetch user data from server
  // try {
  //   const response = await api.get('/auth/cookie/me');
  //   return response.data;
  // } catch (error) {
  //   console.error('Error fetching user data:', error);
  //   return null;
  // }
};

export const logout = async () => {
  return api.post('/auth/cookie/logout');
};

export const loginInputSchema = z.object({
  username: z.string().min(1, 'Required').email('Invalid email'),
  password: z.string().min(5, 'Required'),
});

export const loginWithEmailAndPassword = (data) => {
  return api.postForm('/auth/cookie/login', data);
};

const authConfig = {
  userFn: getUser,
  loginFn: async (data) => {
    await loginWithEmailAndPassword(data);
  },
  logoutFn: logout,
};

// Configure auth with React Query
export const { useUser, useLogin, useLogout, AuthLoader } =
  configureAuth(authConfig);

// Custom AuthLoader component to show the connection
export const CustomAuthLoader = ({ children }) => {
  const queryClient = useQueryClient();
  console.log('AuthLoader using QueryClient:', queryClient);

  return (
    <AuthLoader renderLoading={() => <LoadingScreen />}>
      {children}
    </AuthLoader>
  );
};

export const ProtectedRoute = ({ children }) => {
  const user = useUser();
  const location = useLocation();
  console.log('ProtectedRoute user state:', user);

  // Handle loading state
  if (user.isLoading) {
    console.log('Loading user data...');
    return <LoadingScreen />;
  }

  // Handle error state
  if (user.isError) {
    console.log('Error loading user data:', user.error);
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#ff4444'
      }}>
        Error loading user data. Please try again.
      </div>
    );
  }

  // Handle unauthenticated state
  if (!user.data) {
    console.log('Unauthenticated state');
    // Store the current path for redirect after login
    const currentPath = location.pathname;
    return (
      <Navigate 
        to={paths.auth.login.getHref(currentPath)} 
        replace 
        state={{ from: currentPath }}
      />
    );
  }

  return children;
}; 
